// Angular
import {
	Component,
	ElementRef,
	OnInit,
	Renderer2,
	ViewEncapsulation,
} from "@angular/core";
// Layout
import {
	LayoutConfigService,
	SplashScreenService,
	TranslationService,
} from "../../../core/_base/layout";
// Auth
import { AuthNoticeService } from "../../../core/auth/auth-notice/auth-notice.service";
import { environment } from "../../../../environments";
import { MatDialog } from "@angular/material/dialog";
import { InformationDialogComponent } from "./information-dialog/information-dialog.component";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";

interface IAboutUs {
	privacy: {
		enabled: boolean,
		path: string
	},
	legal: {
		enabled: boolean,
		path: string
	},
	contact: {
		enabled: boolean,
		path: string
	},
}

@Component({
	selector: "kt-auth",
	templateUrl: "./auth.component.html",
	styleUrls: ["./auth.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class AuthComponent implements OnInit {
	// Public properties
	today: number = Date.now();
	headerLogo: string;
	loginBackground: string;
	aboutUsConfig: IAboutUs = {
		privacy: {
			enabled: false,
			path: null
		},
		legal: {
			enabled: false,
			path: null
		},
		contact: {
			enabled: false,
			path: null
		},
	};

	/**
	 * Component constructor
	 *
	 * @param el
	 * @param render
	 * @param layoutConfigService: LayoutConfigService
	 * @param authNoticeService: authNoticeService
	 * @param translationService: TranslationService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(
		private el: ElementRef,
		private render: Renderer2,
		private layoutConfigService: LayoutConfigService,
		public authNoticeService: AuthNoticeService,
		private translationService: TranslationService,
		private splashScreenService: SplashScreenService,
		private informationDialog: MatDialog
	) {
		this.loginBackground = environment.assets.loginBackground;
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.translationService.setLanguage(
			this.translationService.getSelectedLanguage()
		);
		this.headerLogo = this.layoutConfigService.getLogo();

		this.splashScreenService.hide();

		this.aboutUsConfig = environment.aboutUs;
	}

	getLoginBackground() {
		return `url(${this.loginBackground})`;
	}

	/**
	 * Load CSS for this specific page only, and destroy when navigate away
	 * @param styleUrl
	 */
	private loadCSS(styleUrl: string) {
		return new Promise((resolve, reject) => {
			const styleElement = document.createElement("link");
			styleElement.href = styleUrl;
			styleElement.type = "text/css";
			styleElement.rel = "stylesheet";
			styleElement.onload = resolve;
			this.render.appendChild(this.el.nativeElement, styleElement);
		});
	}

	openInformationDialog(filePath: string): void {
		const dialogRef = this.informationDialog.open(InformationDialogComponent,
			{
				width: "60%",
				panelClass: "dialogMobile",
				data: {
					filePath: filePath
				},
			}
		);

		dialogRef.afterClosed().subscribe((confirmed: boolean) => {
			if (confirmed) {
				console.log("closed");
			}
		});
	}
}
